export default [
  {
    id: "default",
    stake_token_name: 'CORE-ETH UNI LP',
    stake_token_emoji: '🔮',
    earn_token_name: 'CORE',
    earn_token_emoji: '🗿',
  }
];